// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"699":"c8409651","700":"b2a23dc8","739":"723099ae","888":"0f2d008c","962":"4ccb1f1f"}[chunkId] + ".chunk.js";
};